import { render, staticRenderFns } from "./showOne.vue?vue&type=template&id=881dea70&scoped=true&"
import script from "./showOne.vue?vue&type=script&lang=js&"
export * from "./showOne.vue?vue&type=script&lang=js&"
import style0 from "./showOne.vue?vue&type=style&index=0&id=881dea70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881dea70",
  null
  
)

export default component.exports